import React from "react";
import { Link } from "react-router-dom";

export const agentPendingApprovalLeadColumns = ({ handleDelete, PAGE_SIZE, pendingToApproval}) => [
  {
    label: "Member ID",
    width: 100,
    render: (row) =>
      <Link to="#">
                {row.profile_id ? (
                  <span>#{row.profile_id}</span>
                ) : (
                  <span>-</span>
                )}
      </Link>
  },

  {
    label: "Client Details",
    key: "name",
    width: 250,
    sortable: true,
    render: (row) => (
      <div className="userdet">
        <div>
          <i className="far fa-user" /> {row.name || "-"}
        </div>
        <div>
          <i className="far fa-mobile-alt" /> {row.contact_no || '-'}
        </div>
        <div>
          <i className="far fa-envelope" /> {row.contact_email || '-'}
        </div>
      </div>
    ),
  },

 

  {
    label: "Date",
    width: 120,
    render: (row) => (
      <>
      
        <span>{row?.createdAt
                ? new Date(row.createdAt).toLocaleDateString("en-GB", {
                    day: "2-digit",
                    month: "short",
                    year: "numeric",
                  })
                : "-"}
                </span>
        
      </>
    ),
  },

  {
    label: "Action",
    width: 140,
    render: (row) => (
      <select
            style={{
              fontSize: 12,
              padding: "2px 5px",
              width: "100%",
              cursor: row.converted_status === "Rejected" ? "not-allowed" : "pointer",
              backgroundColor: row.converted_status === "Rejected" ? "#f5f5f5" : "#fff",
            }}
            defaultValue={row.converted_status || "Pending"} 
            onChange={(e) => pendingToApproval(row, e.target.value)}
            disabled={row.converted_status === "Rejected"} 
          >
            <option value="Pending">Pending</option>
            <option value="Approved">Approved</option>
            <option value="Rejected">Rejected</option>
          </select>
    ),
  },

];
